import KENT from './Images/KENT.png'
import KEITT from './Images/KEITT.png'
import ZILL from './Images/ZILL.png'

import box1 from './boxes/carton-fruitibox.png'
import box2 from './boxes/carton-plateau-colle.png'
import box3 from './boxes/carton-a=rabats-superieurs.png'

export const list = [
    {
        mango_id: 1,
        variety: "Kent",
        img: KENT,
        prix: 4000
    },
    {
        mango_id: 2,
        variety: "Keitt",
        imagw_urk: KEITT,
        prix: 4500
    },
    {
        mango_id: 3,
        variety: "Zill",
        imagw_urk: ZILL,
        prix: 4250
    }
]

export const boxes = [
    {
        id: 1,
        img: box1,
        nom: "Fruitibox"
    },
    {
        id: 2,
        img: box2,
        nom: "Carton plateau collé"
    },
    {
        id: 3,
        img: box3,
        nom: "Carton à rabat supérieur"
    }
];